<template>
  <div
    v-if="loading"
    v-loading="loading"
    class="loading"
    :element-loading-text="i18n.t('transcription.loading')"
  />
  <div v-else-if="isTranscriptionResultEmpty">
    <BEmptyBox
      display-only
    >
      {{ i18n.t('transcription.transcriptionResultIsEmpty') }}
    </BEmptyBox>
  </div>
  <slot v-else />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type TProps = {
  loading: boolean;
  isTranscriptionResultEmpty: boolean;
};
defineProps<TProps>();

const i18n = useI18n();
</script>

<style lang="scss" scoped>
.loading {
  height: 100%;
}
</style>
